export default "__VITE_ASSET__CQWmSrsO__"